import axios from "axios";
import axiosForPdf from "../axios/index"; // used
import * as API from "../app/utils/apiHelper";


let API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
let API_ENDPOINT_V2 = process.env.REACT_APP_API_ENDPOINT_V2;
let API_ENDPOINT_NOAUTH = process.env.REACT_APP_API_ENDPOINT_NOAUTH;

if (process.env.REACT_APP_ENABLE_KEYCLOAK == "true" && process.env.REACT_APP_ENABLE_KEYCLOAK_DIRECT_LOGIN == "true") {
  API_ENDPOINT = process.env.REACT_APP_GATEWAY_APP_API_ENDPOINT;
  API_ENDPOINT_V2 = process.env.REACT_APP_GATEWAY_APP_API_ENDPOINT_V2;
  API_ENDPOINT_NOAUTH = process.env.REACT_APP_GATEWAY_APP_API_ENDPOINT_NOAUTH;
}

const API_ENDPOINT_PDF = process.env.REACT_APP_API_ENDPOINT_PDF; // used this endit

export const fetchPdfForOrder = (payload) => {
  const url = `${API_ENDPOINT}/labPartners/getSasUrlOfReport?orderId=${payload.id}`;
  return API.get(url);
};

export const fetchParsedReport = (payload) => {
  let url = `${API_ENDPOINT_PDF}/json/${payload.id}`;
  if (payload?.query) {
    url = `${url}?${payload.query}`;
  }
  return axiosForPdf.get(url);
};

export const saveAndValidate = (payload) => {
  const url = `${API_ENDPOINT_PDF}/calculate-compliance/`;
  return axiosForPdf.post(url, payload);
};

export const submitReportData = (payload) => {
  const url = `${API_ENDPOINT_PDF}/complete_review/${payload.orderId}`;
  return axiosForPdf.post(url);
};

export const startPdfParsing = (payload) => {
  const url = `${API_ENDPOINT_PDF}/download`;
  return axiosForPdf.post(url, payload);
};

export const markAsNotTestedOrMissing = (payload) => {
  const { action, data } = payload;
  const url = `${API_ENDPOINT_PDF}/reset-items-status/?new_status=${action}`;
  return axiosForPdf.post(url, data);
};

export const login = (payload) => {
  const url = `${API_ENDPOINT}/auth/login`;
  return API.post(url, payload);
};

export const logout = () => {
  const url = `${API_ENDPOINT}/auth/logout`;
  return API.get(url);
};

export const updateLabsAndLogistics = (payload) => {
  const url = `${API_ENDPOINT_V2}/orders/updateLabAndLogistics`;
  return API.post(url, payload);
};

export const updateSampleDetails = (payload) => {
  const url = `${API_ENDPOINT}/sampleDetails/updateSampleDetailsForAOrder?orderId=${payload.orderId}`;
  return API.put(url, payload.data);
};

export const forgotPassword = (payload) => {
  const url = `${API_ENDPOINT}/auth/forgotPassword`;
  return API.post(url, payload);
};

export const resetPassword = (payload) => {
  const url = `${API_ENDPOINT_NOAUTH}/resetPassword/${payload.token}`;
  return API.patch(url, payload.data);
};

export const verifyUserAndSetPassword = (payload) => {
  const url = `${API_ENDPOINT_NOAUTH}/verifyUserAndSetPassword/${payload.token}`;
  return API.patch(url, payload.data);
};

export const fetchMyProfile = (payload) => {
  const url = `${API_ENDPOINT}/users/me`;
  return API.get(url, null);
};

export const fetchAllCompanies = (payload) => {
  const url = `${API_ENDPOINT}/companies${payload?.query ? `?${payload.query}` : ""
    }`;
  return API.get(url);
};

export const fetchCompanyCatalogSummary = (payload) => {
  const url = `${API_ENDPOINT}/companies/catalogSummary?${payload.query}`;
  return API.get(url);
};

export const fetchDropdown = (payload) => {
  const url = `${API_ENDPOINT}/dropdowns?keys=${JSON.stringify(payload)}`;
  return API.get(url);
};

export const fetchAllTests = (payload) => {
  const url = `${API_ENDPOINT}/tests${payload.query ? `?${payload.query}` : ""
    }`;
  return API.get(url);
};

export const fetchAllAvaiblaeTestsToAdd = (payload) => {
  const url = `${API_ENDPOINT}/companies/${payload.id
    }/getTestsAvailableToAddInCatalog${payload.query ? `?${payload.query}` : ""}`;
  return API.get(url);
};

export const fetchFilters = (payload) => {
  const url = `${API_ENDPOINT}/companies/${payload.id}/getCatalogFilters`;
  return API.get(url);
};

export const fetchAllCommodityCategories = (payload) => {
  const url = `${API_ENDPOINT}/commodityCategories`;
  return API.get(url);
};

export const fetchAllTestCategories = (payload) => {
  const url = `${API_ENDPOINT}/testCategories`;
  return API.get(url);
};

export const fetchAllTestCommodities = (payload) => {
  const url = `${API_ENDPOINT}/commodities`;
  return API.get(url);
};

export const fetchAllCommodities = (payload) => {
  const url = `${API_ENDPOINT}/commodities`;
  return API.get(url);
};

export const fetchUserSummary = (payload) => {
  const url = `${API_ENDPOINT}/companies`;
  return API.get(url);
};

export const fetchCompaniesForFilter = (payload) => {
  const url = `${API_ENDPOINT}/companies`;
  return API.get(url);
};

export const fetchAllCountries = (payload) => {
  const url = `${API_ENDPOINT}/countries`;
  return API.get(url);
};

export const fetchAllStates = (payload) => {
  const url = `${API_ENDPOINT}/states?limit=50`;
  return API.get(url);
};

export const fetchAllStatesByCountryId = (payload) => {
  const url = `${API_ENDPOINT}/states/${payload.countryId}`;
  return API.get(url);
};

export const fetchAllCities = (payload) => {
  const url = `${API_ENDPOINT}/cities?limit=10000`;
  return API.get(url);
};

export const fetchAllCitiesByStateId = (payload) => {
  const url = `${API_ENDPOINT}/cities/${payload.stateId}`;
  return API.get(url);
};
export const fetchPaymentMethods = (payload) => {
  const url = `${API_ENDPOINT}/paymentMethods`;
  return API.get(url);
};

export const addCompany = (payload) => {
  const url = `${API_ENDPOINT}/companies`;
  return API.post(url, payload);
};

export const validateUserExists = (payload) => {
  const url = `${API_ENDPOINT}/validations/userExists?email=${payload}`;
  return API.get(url);
};

export const addTest = (payload) => {
  const url = `${API_ENDPOINT}/tests`;
  return API.post(url, payload);
};

export const addTestCategory = (payload) => {
  const url = `${API_ENDPOINT}/testCategories`;
  return API.post(url, payload);
};

export const addCommodityCategory = (payload) => {
  const url = `${API_ENDPOINT}/commodityCategories`;
  return API.post(url, payload);
};

export const addCommodity = (payload) => {
  const url = `${API_ENDPOINT}/commodities`;
  return API.post(url, payload);
};

export const requestCorrection = (payload) => {
  const url = `${API_ENDPOINT_V2}/orders/addComment`;
  return API.post(url, payload);
};

export const fetchCompanyUsers = (payload) => {
  const url = `${API_ENDPOINT}/companies/${payload.id}/users`;
  return API.get(url);
};

export const fetchCompanyDetails = (payload) => {
  const url = `${API_ENDPOINT}/companies/${payload.id}`;
  return API.get(url);
};

export const fetchCompanyFeatures = (payload) => {
  const url = `${API_ENDPOINT}/companyFeatures/${payload.companyId}`;
  return API.get(url);
};

export const fetchCompanyCatalog = (payload) => {
  const url = `${API_ENDPOINT}/companies/${payload.id}/catalog${payload.query ? `?${payload.query}` : ""
    }`;
  return API.get(url);
};

export const fetchCommoditiesForCompanyCatalog = (payload) => {
  const url = `${API_ENDPOINT}/catalogs/${payload.companyId}/commodities`;
  return API.get(url);
};

export const fetchTestsForCommodityCatalog = (payload) => {
  const url = `${API_ENDPOINT}/catalogs/${payload.companyId}/commodity/${payload.commodityId}/tests`;
  return API.get(url);
};

export const addUser = (payload) => {
  const url = `${API_ENDPOINT}/companies/${payload.company}/users`;
  return API.post(url, payload);
};

export const addToCart = (payload) => {
  const url = `${API_ENDPOINT}/carts`;
  return API.post(url, payload);
};

export const fetchCart = (payload) => {
  const url = `${API_ENDPOINT}/carts`;
  return API.get(url);
};

export const updateCart = (payload) => {
  const url = `${API_ENDPOINT}/carts/${payload.id}`;
  return API.post(url, payload.data);
};

export const placeOrder = (payload) => {
  const url = `${API_ENDPOINT}/orders`;
  return API.post(url, payload);
};

export const fetchAllOrders = (payload) => {
  const url = `${API_ENDPOINT_V2}/orders/${payload?.query ? `?${payload.query}` : ""
    }`;
  return API.get(url);
};

export const fetchAllOrdersForLab = (payload) => {
  const url = `${API_ENDPOINT}/labPartners/ordersForLab/${payload.status}${payload?.query ? `?${payload.query}` : ""
    }`;
  return API.get(url);
};

export const fetchAllOrderReportsList = (payload) => {
  const url = `${API_ENDPOINT}/labPartners/reviewSystemForLab/${payload?.query ? `?${payload.query}` : ""
    }`;
  return API.get(url);
};

export const fetchAllCommoditiesForLab = (payload) => {
  const url = `${API_ENDPOINT}/commodities`;
  return API.get(url);
};

export const getFileUrl = (payload) => {
  //const url = `${API_ENDPOINT}/files/link`;
  const url = `${API_ENDPOINT}/files/fetchsastoken`;
  console.log(payload);
  return API.post(url, payload);
};

export const uploadFile = (payload) => {
  const { url, data } = payload;
  const azureAxios = axios.create();

  return azureAxios({
    url,
    method: "PUT",
    headers: {
      "Content-Type": data.type,
      "x-ms-blob-type": "BlockBlob",
    },
    withCredentials: false,
    data: data,
  });
};

export const fetchUser = (payload) => {
  const url = `${API_ENDPOINT}/users`;
  return API.get(url);
};

export const fetchAllLabs = (payload) => {
  const url = `${API_ENDPOINT}/labPartners`;
  return API.get(url);
};

export const fetchOrderCounts = (payload) => {
  const url = `${API_ENDPOINT}/labPartners/fetchallorderscountforlab`;
  return API.get(url);
};

export const fetchLabDetails = (payload) => {
  const url = `${API_ENDPOINT}/labPartners/${payload.id}`;
  return API.get(url);
};

export const fetchAllLogisticPartners = (payload) => {
  const url = `${API_ENDPOINT}/logisticPartners`;
  return API.get(url);
};

export const fetchLogisticDetails = (payload) => {
  const url = `${API_ENDPOINT}/logisticPartners/${payload.id}`;
  return API.get(url);
};

export const fetchNeedCorrectionCommentsForOrder = (payload) => {
  const url = `${API_ENDPOINT_V2}/orders/getNeedCorrectionCommentsForOrder${payload?.query ? `?${payload.query}` : ""
    }`;
  return API.get(url);
};

export const addLab = (payload) => {
  const url = `${API_ENDPOINT}/labPartners`;
  return API.post(url, payload);
};

export const addOrder = (payload) => {
  const url = `${API_ENDPOINT_V2}/orders/create`;
  const data = payload.data;
  return API.post(url, data);
};

export const addLogistics = (payload) => {
  const url = `${API_ENDPOINT}/logisticPartners`;
  return API.post(url, payload);
};

export const editLab = (payload) => {
  const url = `${API_ENDPOINT}/labPartners/${payload.id}`;
  return API.put(url, payload.data);
};

export const editLogistic = (payload) => {
  const url = `${API_ENDPOINT}/logisticPartners/${payload._id}`;
  return API.put(url, payload);
};

export const fetchOrderDetails = (payload) => {
  const url = `${API_ENDPOINT}/orders/${payload}`;
  return API.get(url);
};

export const updateOrderStatus = (payload) => {
  const url = `${API_ENDPOINT}/orders/changeStatusOfOrderId`;
  return API.post(url, payload);
};

export const fetchSampleDetailsForOrder = (payload) => {
  const url = `${API_ENDPOINT}/labPartners/getLabSampleDetailsForAnOrder?orderId=${payload}`;
  return API.get(url);
};

export const createReplacementOrder = (payload) => {
  const url = `${API_ENDPOINT_V2}/orders/createReplacement`;
  return API.post(url, payload.data);
};

export const rejectOrder = (payload) => {
  const url = `${API_ENDPOINT}/labPartners/rejectorderbylab`;
  return API.postDCT(url, payload.data);
};

export const fetchSampleDetails = (payload) => {
  const query = new URLSearchParams();
  if (payload) query.append("orderId", payload);

  const url = `${API_ENDPOINT}/orders/getSampleDetailsOfOrderId?${query.toString()}`;
  return API.get(url);
};

export const updateOrder = (payload) => {
  const url = `${API_ENDPOINT}/orders/assignLabToOrderId`;
  return API.post(url, payload.data);
};

export const assignSampler = (payload) => {
  const url = `${API_ENDPOINT}/orders/assignSampler`;
  return API.post(url, payload.data);
};

export const addGRNForOrder = (payload) => {
  const url = `${API_ENDPOINT}/orders/${payload.id}/addGRN`;
  return API.patch(url, payload.data);
};

export const editGRNForOrder = () => { };

export const getDownloadUrl = (payload) => {
  const url = `${API_ENDPOINT}/files/download`;
  return API.post(url, payload.data);
};
export const downloadFile = (payload) => {
  const { url } = payload;

  console.log("url", url);
  const sharedAxiosRequestConfig = {
    withCredentials: false,
    url,
  };

  return axios({
    ...sharedAxiosRequestConfig,
    headers: { "Content-Type": "application/octet-stream" },
    method: "GET",
    responseType: "blob",
  });
};
export const updateCompanyCatalog = (payload) => {
  const url = `${API_ENDPOINT}/companies/${payload.id}/catalog`;
  return API.patch(url, payload.data);
};

export const updatePriceOfTestInCompanyCatalog = (payload) => {
  const url = `${API_ENDPOINT}/companies/${payload.id}/catalog/updateTestPrice`;
  return API.patch(url, payload.data);
};

export const removeTestInCompanyCatalog = (payload) => {
  const url = `${API_ENDPOINT}/companies/${payload.id}/catalog/deleteTestFromCatalog/${payload.data.testId}`;
  return API.deleteResource(url);
};

export const fetchUserCompanyDetails = (payload) => {
  const url = `${API_ENDPOINT}/users/company`;
  return API.get(url);
};

export const addCompanyAddress = (payload) => {
  const url = `${API_ENDPOINT}/companies/${payload.id}/address`;
  return API.post(url, payload.data);
};

export const fetchPickupAddressForCompany = (payload) => {
  let url = "";
  if (payload.query) {
    url = `${API_ENDPOINT}/addresses/findAllPickupAddressesForSpecificCompany/${payload.id}?${payload.query}`;
  } else {
    url = `${API_ENDPOINT}/addresses/findAllPickupAddressesForSpecificCompany/${payload.id}`;
  }
  return API.get(url);
};

export const fetchBillingAddressForCompany = (payload) => {
  let url = "";
  if (payload.query) {
    url = `${API_ENDPOINT}/addresses/findAllBillingAddressesForSpecificCompany/${payload.id}?${payload.query}`;
  } else {
    url = `${API_ENDPOINT}/addresses/findAllBillingAddressesForSpecificCompany/${payload.id}`;
  }
  return API.get(url);
};

export const addAddress = (payload) => {
  const url = `${API_ENDPOINT}/addresses`;
  return API.post(url, payload.data);
};

export const updateAddress = (payload) => {
  const url = `${API_ENDPOINT}/addresses/${payload.id}`;
  return API.put(url, payload.data);
};

export const fetchUserDetails = (payload) => {
  const url = `${API_ENDPOINT}/users/${payload.id}`;
  return API.get(url);
};

export const fetchPickupAddressesForUser = (payload) => {
  let url = `${API_ENDPOINT}/users/address/fetchPickupAddress/${payload.userId}?page=${payload.page}&pageSize=${payload.pageSize}`;
  if (payload.name) url = url + `&name=${payload.name}`;
  return API.get(url);
};

export const fetchBillingAddressesForUser = (payload) => {
  let url = `${API_ENDPOINT}/users/address/fetchBillingAddress/${payload.userId}?page=${payload.page}&pageSize=${payload.pageSize}`;
  if (payload.name) url = url + `&name=${payload.name}`;
  return API.get(url);
};

export const updateUserDetails = (payload) => {
  const url = `${API_ENDPOINT}/users/${payload.id}`;
  return API.patch(url, payload.data);
};

export const updateCompany = (payload) => {
  const url = `${API_ENDPOINT}/companies/${payload.id}`;
  return API.put(url, payload.data);
};

export const fetchCatalogForUser = () => {
  const url = `${API_ENDPOINT}/catalogs`;
  return API.get(url);
};

export const requestReportHardCopy = (payload) => {
  const url = `${API_ENDPOINT}/orders/${payload.id}/requestReportHardCopy`;
  return API.post(url);
};

export const raiseDispute = (payload) => {
  const url = `${API_ENDPOINT}/orders/${payload.id}/raiseDispute`;
  return API.post(url, payload.data);
};

export const contactSupport = (payload) => {
  const url = `${API_ENDPOINT}/serviceRequest`;
  return API.post(url, payload.data);
};

export const provideFeedback = (payload) => {
  const url = `${API_ENDPOINT}/orderFeedback/${payload.orderId}`;
  return API.post(url, payload.data);
};

export const fetchRecommendedPackages = () => {
  const url = `${API_ENDPOINT}/packages`;
  return API.get(url);
};

export const fetchCompanyPackages = (payload) => {
  const { company, page, limit, filters } = payload;
  const queryParams = new URLSearchParams();
  if (page) queryParams.append("page", page);
  if (limit) queryParams.append("limit", limit);
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length > 0) {
        value.forEach((val) => queryParams.append(key, val));
      } else if (value) {
        queryParams.append(key, value);
      }
    });
  }

  const query = queryParams.toString();
  const companyId = encodeURIComponent(company);
  const url = `${API_ENDPOINT}/packages/company/${companyId}?${query}`;
  return API.get(url);
};

export const createPackage = (payload) => {
  const url = `${API_ENDPOINT}/packages`;
  return API.post(url, payload.data);
};

export const fetchPackage = (payload) => {
  const url = `${API_ENDPOINT}/packages/${payload.id}`;
  return API.get(url);
};

export const updatePackage = (payload) => {
  const url = `${API_ENDPOINT}/packages/${payload.id}`;
  return API.post(url, payload.data);
};

export const createDirectOrder = (payload) => {
  const url = `${API_ENDPOINT}/orders/direct`;
  return API.post(url, payload.data);
};

export const updatePurchaseOrder = (payload) => {
  const url = `${API_ENDPOINT}/orders/${payload.id}`;
  return API.patch(url, payload.data);
};

export const addPersonalPickupAddress = (payload) => {
  const url = `${API_ENDPOINT}/users/pickupAddress`;
  // const url = `${API_ENDPOINT}/companies/${payload.id}/address`;
  return API.post(url, payload.data);
  // return API.post(url, payload.data);
};

export const fetchPaymentReport = (payload) => {
  const url = `${API_ENDPOINT}/orders/paymentReport`;
  return API.get(url);
};

export const fetchPendingPaymentOrders = (payload) => {
  const url = `${API_ENDPOINT}/orders/fetchPendingOrders/${payload.companyId}`;
  return API.get(url);
};

export const sendPaymentReminder = (payload) => {
  const url = `${API_ENDPOINT}/companies/${payload.id}/sendPaymentReminder`;
  return API.post(url);
};

export const fetchTopPackages = (payload) => {
  let url = `${API_ENDPOINT}/labxAnalytics/topPackages?`;
  if (payload?.createdAtFrom)
    url =
      url +
      `createdAtFrom=${payload.createdAtFrom}&createdAtTo=${payload.createdAtTo}`;
  if (payload?.user) url = url + `&user=${payload.user}`;
  return API.get(url);
};

export const fetchTopCommodities = (payload) => {
  let url = `${API_ENDPOINT}/labxAnalytics/topCommodities?`;
  if (payload?.createdAtFrom)
    url =
      url +
      `createdAtFrom=${payload.createdAtFrom}&createdAtTo=${payload.createdAtTo}`;
  if (payload?.user) url = url + `&user=${payload.user}`;
  return API.get(url);
};

export const fetchAvgTATOnPackages = (payload) => {
  let url = `${API_ENDPOINT}/labxAnalytics/avgTATPerPackage?`;
  if (payload?.createdAtFrom)
    url =
      url +
      `createdAtFrom=${payload.createdAtFrom}&createdAtTo=${payload.createdAtTo}`;
  if (payload?.user) url = url + `&user=${payload.user}`;
  return API.get(url);
};

export const fetchAvgTATOnCommodities = (payload) => {
  let url = `${API_ENDPOINT}/labxAnalytics/avgTATPerCommodity?`;
  if (payload?.createdAtFrom)
    url =
      url +
      `createdAtFrom=${payload.createdAtFrom}&createdAtTo=${payload.createdAtTo}`;
  if (payload?.user) url = url + `&user=${payload.user}`;
  return API.get(url);
};

export const fetchOrdersInfoForAnalytics = (payload) => {
  let url = `${API_ENDPOINT}/companyAdminAnalytics/ordersForAnalytics?`;
  if (payload?.createdAtFrom)
    url =
      url +
      `createdAtFrom=${payload.createdAtFrom}&createdAtTo=${payload.createdAtTo}`;
  if (payload?.user) url = url + `&user=${payload.user}`;
  return API.get(url);
};

export const saveLabSampleResponseDetails = (payload) => {
  let url = `${API_ENDPOINT}/labPartners/savesampledetails/${payload.orderId}`;
  return API.post(url, payload);
};

export const saveLabResponseDetails = (payload) => {
  console.log("payload", payload);
  let url = `${API_ENDPOINT}/labPartners/savelabresponsedetails/${payload.id}`;
  console.log("API-payload", payload);
  return API.post(
    url,
    payload.data /* {
    headers: { "Content-Type": "multipart/form-data" },
  } */
  );
};

export const fetchDistrictsForState = (payload) => {
  const url = `${API_ENDPOINT}/orders/getDistrictsBasedOnState?stateId=${payload.stateId}`;
  return API.get(url);
};

export const fetchSamplersForDistrict = (payload) => {
  const query = new URLSearchParams();
  if (payload?.stateId) query.append("stateId", payload.stateId);
  if (payload?.districtId) query.append("districtId", payload.districtId);
  if (payload?.agencyId) query.append("agencyId", payload.agencyId);
  const url = `${API_ENDPOINT}/orders/getSamplerBasedOnSatateAndDistrict?${query.toString()}`;
  return API.get(url);
};

export const fetchAllSamplers = (payload) => {
  const url = `${API_ENDPOINT_V2}/sampler/?${payload?.query ? `${payload.query}` : ""
    }`;
  return API.get(url);
};

// This function fetches all project codes based on the company ID
export const fetchAllProjectCodes = (payload) => {
  const query = new URLSearchParams();
  if (payload?.companyId) query.append("companyId", payload.companyId);

  const url = `${API_ENDPOINT_V2}/projects?${query.toString()}`;
  return API.get(url);
};

export const fetchProjectCodesForFilters = (payload) => {
  const url = `${API_ENDPOINT_V2}/projects?${payload}`;
  return API.get(url);
};

// This function fetches all project codes of all the companies
export const fetchAllCompaniesProjectCodes = (payload) => {
  const url = `${API_ENDPOINT_V2}/projects/getAll`;
  return API.get(url);
};

export const addSampler = (payload) => {
  const url = `${API_ENDPOINT_V2}/sampler/addSampler`;
  return API.post(url, {
    name: payload.data.name,
    samplerContact: payload.data.samplerContact,
    address: payload.data.address,
    pincode: payload.data.pincode,
    email: payload.data.email,
    stateId: payload.data.state,
    districtId: payload.data.district,
    agencyId: payload.data.agency,
    operatingStates: payload.data.operatingStates,
    operatingDistricts: payload.data.operatingDistricts,
  });
};

export const fetchSamplerDetails = (payload) => {
  const url = `${API_ENDPOINT_V2}/sampler/getSamplerById?_id=${payload.id}`;
  return API.get(url);
};

export const editSampler = ({ payload }) => {
  console.log(payload);
  const url = `${API_ENDPOINT_V2}/sampler/updateSampler?_id=${payload.id}`;
  return API.put(url, payload.data);
};

export const fetchAllAgencies = (payload) => {
  const url = `${API_ENDPOINT_V2}/agencies/`;
  return API.get(url);
};

export const fetchKitsStatus = (payload) => {
  const url = `${API_ENDPOINT}/dropdowns/?keys=["samplerKitStatus"]`;
  return API.get(url);
};

export const fetchAllKits = (payload) => {
  const {
    searchQuery,
    statusId,
    samplerId,
    stateId,
    districtId,
    agencyId,
    projectCodeId,
    page,
    limit,
  } = payload;

  const query = new URLSearchParams();
  if (searchQuery) query.append("searchQuery", searchQuery);
  if (statusId) query.append("statusId", statusId);
  if (samplerId) query.append("samplerId", samplerId);
  if (stateId) query.append("stateId", stateId);
  if (districtId) query.append("districtId", districtId);
  if (agencyId) query.append("agencyId", agencyId);
  if (projectCodeId) query.append("projectCodeId", projectCodeId);
  if (page) query.append("page", page);
  if (limit) query.append("limit", limit);

  const url = `${API_ENDPOINT_V2}/samplerKit/?${query.toString()}`;
  return API.get(url);
};

export const createKitSeals = (payload) => {
  const url = `${API_ENDPOINT_V2}/samplerKit/create`;
  return API.post(url, payload);
};
export const kitAssignToSampler = (payload) => {
  const url = `${API_ENDPOINT_V2}/sampler/assignSamplerKitToSampler`;
  return API.post(url, payload);
};

export const updateKitStatus = (payload) => {
  const url = `${API_ENDPOINT_V2}/samplerKit/changeStatus`;
  return API.post(url, payload);
};

export const assignLogisticToKit = (payload) => {
  const url = `${API_ENDPOINT_V2}/samplerKit/assignLogisticAndTrackingId`;
  return API.post(url, payload);
};

export const assignLogisticAndTrackingIdToOrder = (payload) => {
  const url = `${API_ENDPOINT_V2}/orders/updateLogisticsAndTrackingId`;
  return API.post(url, payload);
};

export const saveAcceptanceFormData = (payload) => {
  const url = `${API_ENDPOINT}/labPartners/saveLabAcceptanceForm/`;
  return API.post(url, payload.data);
};

export const saveLabellingFormData = (payload) => {
  const url = `${API_ENDPOINT}/labPartners/saveLabelingForm`;
  return API.post(url, payload.data);
};

export const fetchOrderCount = ({ companyIds, projectCodeIds }) => {
  const companyParams = companyIds.map((id) => `companyId=${id}`).join("&");
  const projectParams = projectCodeIds
    .map((id) => `projectCodeId=${id}`)
    .join("&");
  const url = `${API_ENDPOINT}/analytics/orderCount?${companyParams}&${projectParams}`;
  return API.get(url);
};
export const fetchSamplingTrackingSummary = ({ view, filtersString }) => {
  const { companyIds = [], projectCodeIds = [] } = filtersString
    ? JSON.parse(filtersString)
    : {};
  const queryParams = [`view=${view}`];
  if (companyIds.length > 0) {
    queryParams.push(...companyIds.map((id) => `companyId=${id}`));
  }
  if (projectCodeIds.length > 0) {
    queryParams.push(...projectCodeIds.map((id) => `projectCodeId=${id}`));
  }
  const queryString = queryParams.join("&");
  const url = `${API_ENDPOINT}/analytics/samplingTrackingSummary/?${queryString}`;
  return API.get(url);
};
export const fetchSamplingTrackingDetailed = ({ filtersString }) => {
  const { companyIds = [], projectCodeIds = [] } = filtersString
    ? JSON.parse(filtersString)
    : {};

  const queryParams = [
    ...companyIds.map((id) => `companyId=${id}`),
    ...projectCodeIds.map((id) => `projectCodeId=${id}`)
  ];

  const queryString = queryParams.join("&");
  const url = `${API_ENDPOINT}/analytics/completeSamplerTracking/?${queryString}`;

  return API.get(url);
};

export const fetchCommodityAnalyticsSummary = ({ filtersString, view = "top" }) => {
  const { companyIds = [], projectCodeIds = [] } = filtersString
    ? JSON.parse(filtersString)
    : {};
  const queryParams = [
    `view=${view}`,
    ...companyIds.map((id) => `companyId=${id}`),
    ...projectCodeIds.map((id) => `projectCodeId=${id}`),
  ];
  const queryString = queryParams.join("&");
  const url = `${API_ENDPOINT}/analytics/commoditySamplingSummary?${queryString}`;
  return API.get(url);
};

export const fetchCommoditySamplingDetailed = ({ filtersString, page = 1, limit = 10 }) => {
  const { companyIds = [], projectCodeIds = [] } = filtersString
    ? JSON.parse(filtersString)
    : {};
  const queryParams = [
    `page=${page}`,
    `limit=${limit}`,
    ...companyIds.map((id) => `companyId=${id}`),
    ...projectCodeIds.map((id) => `projectCodeId=${id}`)
  ];
  const queryString = queryParams.join("&");
  const url = `${API_ENDPOINT}/analytics/commoditySampling/?${queryString}`;
  return API.get(url);
};
export const fetchTestingAnalyticsSummary = ({ filtersString, sortBy }) => {
  const { companyIds = [], projectCodeIds = [] } = filtersString
    ? JSON.parse(filtersString)
    : {};
  const queryParams = [];
  if (companyIds.length > 0) {
    queryParams.push(...companyIds.map((id) => `companyId=${id}`));
  }
  if (projectCodeIds.length > 0) {
    queryParams.push(...projectCodeIds.map((id) => `projectCodeId=${id}`));
  }
  if (sortBy && (sortBy === 'lowest' || sortBy === 'highest')) {
    queryParams.push(`sortBy=${sortBy}`);
  }
  const queryString = queryParams.join("&");
  const url = `${API_ENDPOINT}/analytics/testingSummary/?${queryString}`;
  return API.get(url);
};
export const fetchTestingAnalyticsDetailed = (filtersString) => {
  const { companyIds = [], projectCodeIds = [] } = filtersString
    ? JSON.parse(filtersString)
    : {};

  const queryParams = [
    ...companyIds.map((id) => `companyId=${id}`),
    ...projectCodeIds.map((id) => `projectCodeId=${id}`)
  ];

  const queryString = queryParams.join("&");
  const url = queryString
    ? `${API_ENDPOINT}/analytics/testing/?${queryString}`
    : `${API_ENDPOINT}/analytics/testing`;

  return API.get(url);
};

export const fetchTATMonitoringSummary = ({ filtersString }) => {
  const { companyIds = [], projectCodeIds = [] } = filtersString
    ? JSON.parse(filtersString)
    : {};
  const queryParams = [];
  if (companyIds.length > 0) {
    queryParams.push(...companyIds.map((id) => `companyId=${id}`));
  }
  if (projectCodeIds.length > 0) {
    queryParams.push(...projectCodeIds.map((id) => `projectCodeId=${id}`));
  }
  const queryString = queryParams.join("&");
  const url = `${API_ENDPOINT}/analytics/tatMonitoringSummary/?${queryString}`;
  return API.get(url);
};
export const fetchTATMonitoringDetailed = ({ filtersString }) => {
  const { companyIds = [], projectCodeIds = [] } = filtersString
    ? JSON.parse(filtersString)
    : {};

  const queryParams = [
    ...companyIds.map((id) => `companyId=${id}`),
    ...projectCodeIds.map((id) => `projectCodeId=${id}`)
  ];

  const queryString = queryParams.join("&");
  const url = queryString
    ? `${API_ENDPOINT}/analytics/tatMonitoring/?${queryString}`
    : `${API_ENDPOINT}/analytics/tatMonitoring`
  return API.get(url);
};
export const fetchKitDetails = (kitId) => {
  const url = `${API_ENDPOINT_V2}/samplerKit/getKitById/?_id=${kitId}`;
  return API.get(url);
};

export const updateKitProjectCode = (payload) => {
  const url = `${API_ENDPOINT_V2}/samplerKit/updateProjectCode`;
  return API.post(url, payload.data);
};

export const addSeals = (payload) => {
  const url = `${API_ENDPOINT_V2}/samplerKit/addExtraSeals`;
  return API.post(url, payload.data);
};

export const addBoxes = (payload) => {
  const url = `${API_ENDPOINT_V2}/samplerKit/addExtraBoxes`;
  return API.post(url, payload.data);
};

export const deleteKit = (payload) => {
  const url = `${API_ENDPOINT_V2}/samplerKit/deleteSamplerKit`;
  return API.deleteItem(url, payload.data);
};

export const addOrUpdateLabOperator = (payload) => {
  const url = `${API_ENDPOINT}/labPartners/labAppUserOnboarding`;
  return API.post(url, payload.data);
};

export const fetchSampleCoverageSummary = ({ filtersString }) => {
  const { companyIds = [], projectCodeIds = [] } = filtersString
    ? JSON.parse(filtersString)
    : {};

  const queryParams = [];

  if (companyIds.length > 0) {
    queryParams.push(...companyIds.map((id) => `companyId=${id}`));
  }

  if (projectCodeIds.length > 0) {
    queryParams.push(...projectCodeIds.map((id) => `projectCodeId=${id}`));
  }

  const queryString = queryParams.join("&");
  const url = `${API_ENDPOINT}/analytics/sampleCoverageSummary/?${queryString}`;

  return API.get(url);
};
export const fetchGeographyAnalytics = ({ filtersString, sortDescending = true }) => {
  const { companyIds = [], projectCodeIds = [] } = filtersString
    ? JSON.parse(filtersString)
    : {};
  const queryParams = [
    ...companyIds.map((id) => `companyId=${id}`),
    ...projectCodeIds.map((id) => `projectCodeId=${id}`)
  ];
  if (!sortDescending) {
    queryParams.push('sort=asc');
  }
  const queryString = queryParams.join("&");
  const url = queryString
    ? `${API_ENDPOINT}/analytics/sampleCoverage?${queryString}`
    : `${API_ENDPOINT}/analytics/sampleCoverage`;

  return API.get(url);
};
export const fetchRegretDashboardData = ({ filtersString }) => {
  const { companyIds = [], projectCodeIds = [] } = filtersString
    ? JSON.parse(filtersString)
    : {};
  const queryParams = [];
  if (companyIds.length > 0) {
    queryParams.push(...companyIds.map((id) => `companyId=${id}`));
  }
  if (projectCodeIds.length > 0) {
    queryParams.push(...projectCodeIds.map((id) => `projectCodeId=${id}`));
  }
  const queryString = queryParams.join("&");
  const url = `${API_ENDPOINT}/analytics/regretCaseTracking${queryString ? `?${queryString}` : ''}`;
  return API.get(url);
};

const REPORT_PARAM_CONFIG = {
  orderDetails: ['companyIds', 'projectCodeIds', 'commodityIds', 'labIds', 'samplerIds', 'stateIds', 'districtIds'],
  sampleDetails: ['companyIds', 'projectCodeIds', 'commodityIds', 'labIds', 'samplerIds', 'stateIds', 'districtIds'],
  boxReport: ['companyIds', 'projectCodeIds', 'labIds', 'samplerIds', 'stateIds', 'districtIds'],
  correctionReport: ['companyIds', 'projectCodeIds'],
  complianceReport: ['companyIds', 'projectCodeIds', 'commodityIds', 'labIds', 'samplerIds', 'stateIds', 'districtIds'],
  complianceMonitoringData: ['companyIds', 'projectCodeIds', 'commodityIds', 'labIds', 'samplerIds', 'stateIds', 'districtIds']
};

export const exportReport = ({ filters, reportType }) => {
  const { companyIds = [], projectCodeIds = [], commodityIds = [], labIds = [], samplerIds = [], stateIds = [], districtIds = [], email } = filters || {};
  const params = new URLSearchParams();
  params.append('reportType', reportType);
  if (email) {
    params.append('email', email);
  }
  const requiredParams = REPORT_PARAM_CONFIG[reportType] || [];
  if (requiredParams.includes('companyIds') && companyIds.length > 0) {
    companyIds.forEach(id => params.append('companyId', id));
  }
  if (requiredParams.includes('projectCodeIds') && projectCodeIds.length > 0) {
    projectCodeIds.forEach(id => params.append('projectCodeId', id));
  }
  if (requiredParams.includes('commodityIds') && commodityIds.length > 0) {
    commodityIds.forEach(id => params.append('commodityId', id));
  }
  if (requiredParams.includes('labIds') && labIds.length > 0) {
    labIds.forEach(id => params.append('labId', id));
  }
  if (requiredParams.includes('samplerIds') && samplerIds.length > 0) {
    samplerIds.forEach(id => params.append('samplerId', id));
  }
  if (requiredParams.includes('districtIds') && districtIds.length > 0) {
    districtIds.forEach(id => params.append('districtId', id));
  }
  if (requiredParams.includes('stateIds') && stateIds.length > 0) {
    stateIds.forEach(id => params.append('stateId', id));
  }
  const queryString = params.toString();
  const url = `${API_ENDPOINT}/reports/async${queryString ? `?${queryString}` : ''}`;
  return API.post(url);
};

export const getSectors = () => {
  const url = `${API_ENDPOINT}/sectors`;
  return API.get(url);
};

export const getCorrectionData = (payload) => {
  const { id } = payload;
  const encodedId = encodeURIComponent(id);
  const url = `${API_ENDPOINT_V2}/orders/getCorrectionDetails/${encodedId}`;
  return API.get(url);
};

export const raiseCorrectionRequest = (payload) => {
  const { id, requestCorrections, remark } = payload;
  const url = `${API_ENDPOINT_V2}/orders/raiseCorrectionRequest`;
  return API.post(url, { id, requestCorrections, remark });
};

export const fetchOverallCompliance = ({ filtersString }) => {
  const { companyIds = [], projectCodeIds = [], parameterRequest } = filtersString
    ? JSON.parse(filtersString)
    : {};
  const queryParams = [];

  if (companyIds.length > 0) {
    queryParams.push(...companyIds.map((id) => `companyId=${id}`));
  }
  if (projectCodeIds.length > 0) {
    queryParams.push(...projectCodeIds.map((id) => `projectCodeId=${id}`));
  }
  if (parameterRequest) {
    queryParams.push(`parameterRequest=${parameterRequest}`);
  }

  const queryString = queryParams.join("&");
  const url = `${API_ENDPOINT}/analytics/overallCompliance?${queryString}`;
  return API.get(url);
};

export const getLabAnalyticsDetails = (payload) => {
  const encodedId = encodeURIComponent(payload?.id);
  const url = `${API_ENDPOINT}/labPartners/labAnalyticsDetails/${encodedId}`;
  return API.get(url);
};
export const fetchComplianceGeographyData = ({ filtersString, dimension = "Overall", level = "both" }) => {
  const { companyIds = [], projectCodeIds = [], parameterRequest } = filtersString
    ? JSON.parse(filtersString)
    : {};

  const queryParams = [];
  queryParams.push(`dimension=${encodeURIComponent(dimension)}`);
  queryParams.push(`level=${encodeURIComponent(level)}`);
  if (companyIds.length > 0) {
    queryParams.push(...companyIds.map((id) => `companyId=${encodeURIComponent(id)}`));
  }
  if (projectCodeIds.length > 0) {
    queryParams.push(...projectCodeIds.map((id) => `projectCodeId=${encodeURIComponent(id)}`));
  }
  if (parameterRequest) {
    queryParams.push(`parameterRequest=${parameterRequest}`);
  }
  const queryString = queryParams.join("&");
  const url = `${API_ENDPOINT}/analytics/geographicalCompliance?${queryString}`;
  return API.get(url);
};
export const fetchParameterCompliance = ({ filtersString }) => {
  const { companyIds = [], projectCodeIds = [], viewType, parameterType, testType, parameterRequest } = filtersString
    ? JSON.parse(filtersString)
    : {};

  const queryParams = [];
  if (companyIds.length > 0) {
    queryParams.push(...companyIds.map((id) => `companyId=${id}`));
  }
  if (projectCodeIds.length > 0) {
    queryParams.push(...projectCodeIds.map((id) => `projectCodeId=${id}`));
  }
  if (viewType) queryParams.push(`view_type=${viewType}`);
  if (parameterType) queryParams.push(`parameter_type=${parameterType}`);
  if (testType) queryParams.push(`test_type=${testType}`);
  if (parameterRequest) {
    queryParams.push(`parameterRequest=${parameterRequest}`);
  }
  const queryString = queryParams.join("&");
  const url = `${API_ENDPOINT}/analytics/parameterWiseComplianceSummary?${queryString}`;
  return API.get(url);
};
export const fetchParameterAnalyticsDetailed = ({ filtersString, pagination, filters }) => {
  const {
    companyIds = [],
    projectCodeIds = [],
    selectedCommodities = [],
    selectedTestingTypes = [],
    parameterRequest,
  } = filtersString ? JSON.parse(filtersString) : {};

  const queryParams = [
    ...companyIds.map((id) => `companyId=${id}`),
    ...projectCodeIds.map((id) => `projectCodeId=${id}`),
    ...(selectedCommodities.length > 0 ? [`commodity=${selectedCommodities.join(',')}`] : []),
    ...(selectedTestingTypes.length > 0 ? [`test_type=${selectedTestingTypes.join(',')}`] : []),
  ];
  if (filters) {
    if (filters.parameterType && filters.parameterType !== "All") {
      queryParams.push(`parameter_type=${filters.parameterType}`);
    }

    if (filters.sortBy) {
      queryParams.push(`sort_by=${filters.sortBy}`);
    }

    if (filters.sortOrder) {
      queryParams.push(`sort_order=${filters.sortOrder}`);
    }
  }
  if (pagination) {
    queryParams.push(`page=${pagination.currentPage || 1}`);
    queryParams.push(`limit=${pagination.pageSize || 10}`);
  }

  if (parameterRequest) {
    queryParams.push(`parameterRequest=${parameterRequest}`);
  }
  const queryString = queryParams.join("&");
  const url = queryString
    ? `${API_ENDPOINT}/analytics/parameterWiseComplianceComplete/?${queryString}`
    : `${API_ENDPOINT}/analytics/parameterWiseComplianceComplete`;

  return API.get(url);
};

export const fetchDistrictsOfMultipleStates = (payload) => {
  const { stateIds } = payload;
  const query = new URLSearchParams();
  stateIds.forEach((id) => query.append("stateId", id));
  const url = `${API_ENDPOINT}/orders/getDistrictsOfMultiStates?${query.toString()}`;
  return API.get(url);
};
export const fetchEligibleOrders = ({ samplerBoxId }) => {
  const queryParams = [];
  if (samplerBoxId) {
    queryParams.push(`samplerBoxId=${samplerBoxId}`);
  }
  const queryString = queryParams.join("&");
  const url = `${API_ENDPOINT_V2}/samplerKit/listValidOrderIdsToBeAdddedInBox?${queryString}`;
  return API.get(url);
};

export const addOrdersToBox = (data) => {
  return API.post(`${API_ENDPOINT_V2}/samplerKit/addOrderToBoxByAdmin`, data);
};
export const removeOrderFromBox = (data) => {
  return API.post(`${API_ENDPOINT_V2}/samplerKit/removeOrdersFromSamplerBoxByAdmin`, data);
};
export const changeBoxStatusByAdmin = (payload) => {
  return API.post(
    `${API_ENDPOINT_V2}/samplerKit/changeStatusOfSamplerBoxByAdmin`,
    payload
  );
};
export const markSealAsUnusedByAdmin = (sampleSealId) => {
  return API.post(
    `${API_ENDPOINT_V2}/samplerKit/markSealAsUnusedByAdmin?sampleSealId=${sampleSealId}`
  );
};
export const getReportJobs = ({ page = 1, limit = 10, filtersString }) => {
  const filters = filtersString ? JSON.parse(filtersString) : {};
  const queryParams = [];
  queryParams.push(`page=${page}`, `limit=${limit}`);

  Object.entries(filters).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      queryParams.push(...value.map((v) => `${key}=${v}`));
    } else if (value !== undefined && value !== null && value !== "") {
      queryParams.push(`${key}=${value}`);
    }
  });

  const queryString = queryParams.join("&");
  const url = `${API_ENDPOINT}/reports/jobs?${queryString}`;

  return API.get(url);
};
export const fetchCommodityWiseCompliance = ({ filtersString, category = "Overall", view = "top" }) => {
  const { companyIds = [], projectCodeIds = [], parameterRequest } = filtersString
    ? JSON.parse(filtersString)
    : {};

  const queryParams = [];

  if (companyIds.length > 0) {
    queryParams.push(...companyIds.map((id) => `companyId=${id}`));
  }
  if (projectCodeIds.length > 0) {
    queryParams.push(...projectCodeIds.map((id) => `projectCodeId=${id}`));
  }

  if (parameterRequest) {
    queryParams.push(`parameterRequest=${parameterRequest}`);
  }

  queryParams.push(`category=${category}`);
  queryParams.push(`view=${view}`);
  const queryString = queryParams.join("&");
  const url = `${API_ENDPOINT}/analytics/commodityWiseCompliance?${queryString}`;

  return API.get(url);
};

export const getLabOrderCountAnalytics = (payload) => {
  const { selectedCommodities, dateRange } = payload;

  const params = new URLSearchParams();
  if (selectedCommodities && selectedCommodities.length > 0) {
    selectedCommodities.forEach((id) => params.append("commodityId", id));
  }
  if (dateRange?.startDate) {
    params.append("dateFrom", dateRange.startDate);
  }
  if (dateRange?.endDate) {
    params.append("dateTo", dateRange.endDate);
  }
  const url = `${API_ENDPOINT}/labPartners/dashboard/orderfunnelcount?${params.toString()}`;
  return API.get(url);
};

export const getLabOrderByStage = (payload) => {
  const { selectedCommodities, dateRange } = payload;

  const params = new URLSearchParams();
  if (selectedCommodities && selectedCommodities.length > 0) {
    selectedCommodities.forEach((id) => params.append("commodityId", id));
  }
  if (dateRange?.startDate) {
    params.append("dateFrom", dateRange.startDate);
  }
  if (dateRange?.endDate) {
    params.append("dateTo", dateRange.endDate);
  }
  const url = `${API_ENDPOINT}/labPartners/dashboard/orderbystage?${params.toString()}`;
  return API.get(url);
};

export const getLabCommodityWiseOrders = (payload) => {
  const { selectedCommodities, dateRange, view } = payload;

  const params = new URLSearchParams();
  if (view) {
    params.append("view", view);
  }
  if (selectedCommodities && selectedCommodities.length > 0) {
    selectedCommodities.forEach((id) => params.append("commodityId", id));
  }
  if (dateRange?.startDate) {
    params.append("dateFrom", dateRange.startDate);
  }
  if (dateRange?.endDate) {
    params.append("dateTo", dateRange.endDate);
  }
  const url = `${API_ENDPOINT}/labPartners/dashboard/commoditywiseorders?${params.toString()}`;
  return API.get(url);
};

export const getLabRejectedOrders = (payload) => {
  const { selectedCommodities, dateRange } = payload;

  const params = new URLSearchParams();

  if (selectedCommodities && selectedCommodities.length > 0) {
    selectedCommodities.forEach((id) => params.append("commodityId", id));
  }
  if (dateRange?.startDate) {
    params.append("dateFrom", dateRange.startDate);
  }
  if (dateRange?.endDate) {
    params.append("dateTo", dateRange.endDate);
  }
  const url = `${API_ENDPOINT}/labPartners/dashboard/rejectedorders?${params.toString()}`;
  return API.get(url);
};

export const getLabDisputeAnalysis = (payload) => {
  const { selectedCommodities, dateRange } = payload;

  const params = new URLSearchParams();

  if (selectedCommodities && selectedCommodities.length > 0) {
    selectedCommodities.forEach((id) => params.append("commodityId", id));
  }
  if (dateRange?.startDate) {
    params.append("dateFrom", dateRange.startDate);
  }
  if (dateRange?.endDate) {
    params.append("dateTo", dateRange.endDate);
  }
  const url = `${API_ENDPOINT}/labPartners/dashboard/dispute-analysis?${params.toString()}`;
  return API.get(url);
};

export const getLabReportReviewStatus = (payload) => {
  const { selectedCommodities, dateRange } = payload;

  const params = new URLSearchParams();

  if (selectedCommodities && selectedCommodities.length > 0) {
    selectedCommodities.forEach((id) => params.append("commodityId", id));
  }
  if (dateRange?.startDate) {
    params.append("dateFrom", dateRange.startDate);
  }
  if (dateRange?.endDate) {
    params.append("dateTo", dateRange.endDate);
  }
  const url = `${API_ENDPOINT}/labPartners/dashboard/review-reports-status?${params.toString()}`;
  return API.get(url);
};

export const fetchHederaVerificationData = ({ orderId, IsAuthorized }) => {

  const endpoint = IsAuthorized
    ? `${API_ENDPOINT}/transactions/getByOrderId/${orderId}`
    : `${API_ENDPOINT}/transactions/public/getByOrderId/${orderId}`;

  return API.get(endpoint);
};

export const fetchReportVerificationData = (hash) => {
  return API.get(`${API_ENDPOINT}/transactions/getByHash/${hash}`);
}
export const sendOrderReportEmail = ({ orderId, emailIds = [] }) => {
  const params = new URLSearchParams();
  if (orderId) {
    params.append('orderId', orderId);
  }
  if (emailIds.length > 0) {
    emailIds.forEach(email => params.append('emailId', email));
  }
  const queryString = params.toString();
  const url = `${API_ENDPOINT}/reports/orderPdfReport/sendEmail${queryString ? `?${queryString}` : ''}`;
  return API.get(url);
};
export const fetchPackagesByCompanyAndCommodity = ({ companyId, commodityId, sampleVariant }) => {
  return API.get(
    `${API_ENDPOINT}/packages/getByCompanyAndCommodity?companyId=${companyId}&commodityId=${commodityId}&sampleVariant=${sampleVariant}`
  );
};

export const uploadBulkOrders = ({ file, email }) => {
  const formData = new FormData();
  formData.append('file', file, file.name);
  const url = `${API_ENDPOINT_V2}/orders/createBulkOrders?email=${encodeURIComponent(email)}`;
  return API.postDCT(url, formData);
};

export const fetchLabCommodityWiseDetailedOrders = (payload) => {
  const { selectedCommodities, dateRange } = payload;

  const params = new URLSearchParams();

  if (selectedCommodities && selectedCommodities.length > 0) {
    selectedCommodities.forEach((id) => params.append("commodityId", id));
  }
  if (dateRange?.startDate) {
    params.append("dateFrom", dateRange.startDate);
  }
  if (dateRange?.endDate) {
    params.append("dateTo", dateRange.endDate);
  }
  const url = `${API_ENDPOINT}/labPartners/dashboard/commodity-wise-details?${params.toString()}`;
  return API.get(url);
};


export const fetchProjectConfig = (payload) => {
  const { projectCodeId } = payload;
  return API.get(
    `${API_ENDPOINT_V2}/projects/projectDetails?projectId=${projectCodeId}`
  );
};

export const updateOrderDocuments = ({ orderId, data }) => {
  return API.post(
    `${API_ENDPOINT}/orders/updateDocuments/?_id=${orderId}`,
    data
  );
};

export const fetchAgencies = (payload) => {
  return API.get(`${API_ENDPOINT_V2}/agencies`);
};

export const fetchOrderCorrectionReasons = () => {
  return API.get(`${API_ENDPOINT_V2}/orders/getOrderCorrectionReasons`);
};

export const orderCorrectionRequest = ({ data }) => {
  return API.post(`${API_ENDPOINT_V2}/orders/moveOrderToOrderCorrection`, data);
};

export const updateOrderDetails = ({ data }) => {
  return API.post(`${API_ENDPOINT_V2}/orders/updateOrderDetails`, data);
};

export const getSampleSealType = (payload) => {
  return API.get(`${API_ENDPOINT}/sampleSeal/getSampleSealType`);
};

export const addSticker = ({ data }) => {
  return API.post(`${API_ENDPOINT_V2}/samplerKit/addExtraStickers`, data);
};

export const addDevice = ({ data }) => {
  return API.post(`${API_ENDPOINT_V2}/samplerKit/addExtraDevices`, data);
};